/**
 * メニュー設定
 */
import * as types from "../../mutation-types/driver-types";

const getDefaultState = () => {
  return {
    menu_key: "1_0",
  }
}


const driver_app_variable = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
  },
  actions: {
    saveMenuKey({ commit, state }, { menuKey }) {
      commit(types.DRIVER_APP_MENU_KEY, { menuKey: menuKey });
    },
    resetState ({ commit }) {
      commit(types.DRIVER_RESET_APP_MENU_KEY)
    },
  },
  mutations: {
    [types.DRIVER_RESET_APP_MENU_KEY] (state) {
      Object.assign(state, getDefaultState())
    },
    [types.DRIVER_APP_MENU_KEY] (state, { menuKey }) {
      state.menu_key = menuKey;
    }
  },

}

export default driver_app_variable
